import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { IonicModule } from '@ionic/angular';
import { EditorToolbarButtonComponent } from '../ui-editor-toolbar-button/ui-editor-toolbar-button.component';
import { EditorFormatState, FormatCommandType } from '../../types';
import { MarkdownEditorService } from '../../services/markdown-editor.service';

@Component({
  selector: 'bl-editor-toolbar',
  standalone: true,
  imports: [CommonModule, IonicModule, EditorToolbarButtonComponent],
  templateUrl: 'ui-editor-toolbar.component.html',
  styleUrls: ['./ui-editor-toolbar.component.scss']
})
export class EditorToolbarComponent {
  @Input() formatState!: EditorFormatState;

  constructor(private editorService: MarkdownEditorService) {}

  onHeadingClick(tag: 'h1' | 'h2' | 'h3'): void {
    this.editorService.executeFormatCommand({
      type: FormatCommandType.HEADING,
      payload: tag
    });
  }

  onBoldClick(): void {
    this.editorService.executeFormatCommand({ type: FormatCommandType.BOLD });
  }

  onItalicClick(): void {
    this.editorService.executeFormatCommand({ type: FormatCommandType.ITALIC });
  }

  onStrikethroughClick(): void {
    this.editorService.executeFormatCommand({
      type: FormatCommandType.STRIKETHROUGH
    });
  }

  onUnderlineClick(): void {
    this.editorService.executeFormatCommand({
      type: FormatCommandType.UNDERLINE
    });
  }

  onQuoteClick(): void {
    this.editorService.executeFormatCommand({ type: FormatCommandType.QUOTE });
  }

  onLinkClick(): void {
    this.editorService.executeFormatCommand({ type: FormatCommandType.LINK });
  }

  onBulletListClick(): void {
    this.editorService.executeFormatCommand({
      type: FormatCommandType.BULLET_LIST
    });
  }

  onNumberedListClick(): void {
    this.editorService.executeFormatCommand({
      type: FormatCommandType.NUMBERED_LIST
    });
  }

  onParagraphClick(): void {
    this.editorService.executeFormatCommand({
      type: FormatCommandType.PARAGRAPH
    });
  }
}
